"use strict";
exports.__esModule = true;
exports.NotificationTypes = void 0;
var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["RatingScreenTitle"] = "rating_screen_title";
    NotificationTypes["PostRatingPositiveTitle"] = "post_rating_positive_title";
    NotificationTypes["PostRatingNegativeTitle"] = "post_rating_negative_title";
})(NotificationTypes = exports.NotificationTypes || (exports.NotificationTypes = {}));
//# sourceMappingURL=notification_type.js.map